import axios from "axios";

// import Cookies from "js-cookie";
import store from "../store";

// let token = Cookies.get("logs");

let token = store.getState().admin.token;

// console.log("object", store.getState().admin.token);

export const updateToken = (tok) => {
  // use this function after index.js runs not before that so any component can run that safely
  token = tok;
};

axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL;
axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

axios.interceptors.request.use(
  function (config) {
    config.headers.Authorization = token ? `Bearer ${token}` : "";
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);
